module.exports = __webpack_public_path__ + "assets/favicons/browserconfig.xml";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=assets/favicons/[name].[ext]!./src/assets/favicons/browserconfig.xml
// module id = /vjv
// module chunks = 1